import { animations } from './components/animations.js';
import { desktopMenu } from './components/desktop-menu.js';
import { faqs } from './components/faqs.js';
import { formTranslation } from './components/form-translation.js';
import { llmsLowercase } from './components/llms-lowercase.js';
import { loadMore } from './components/load-more';
import { mobileMenu } from './components/mobile-menu.js';
import { moreLessText } from './components/more-less-text.js';
import { peopleModal } from './components/people-modal.js';
import { publicComments } from './components/public-comments.js';
import { scrollSnapButton } from './components/scroll-snap-button.js';
import { search } from './components/search.js';
import { statsCounter } from './components/stats-counter.js';
import { tabs } from './components/tabs.js';
import { videoLightbox } from './components/video-lightbox.js';

const rdy = (fn) => {
	if (!document.body) document.addEventListener('DOMContentLoaded', fn);
	else fn();
};

rdy(() => {
	// site wide
	animations();
	desktopMenu();
	mobileMenu();
	search();
	// blocks + components
	faqs();
	formTranslation();
	llmsLowercase();
	loadMore();
	moreLessText();
	peopleModal();
	publicComments();
	scrollSnapButton();
	statsCounter();
	tabs();
	videoLightbox();
});
